import { render, staticRenderFns } from "./RunListForm.vue?vue&type=template&id=2510916a&"
import script from "./RunListForm.vue?vue&type=script&lang=js&"
export * from "./RunListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports